export const LogoSmall = (props: any) => {
  return (
    <svg
      className={props.className}
      width="964"
      height="1028"
      viewBox="0 0 964 1028"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M278.465 951.852C262.343 911.543 306.386 887.126 320.347 879.511L712.512 769.096L911.987 896.036C940.271 914.035 947.925 951.937 928.843 979.502C910.292 1006.3 873.42 1012.63 845.423 995.941C496.551 788.024 307.565 1024.61 278.465 951.852Z"
        fill="#339BFA"
      />
      <path
        d="M914.301 456.891C914.301 709.226 709.744 913.783 457.41 913.783C205.076 913.783 0.518433 709.226 0.518433 456.891C0.518433 204.557 205.076 0 457.41 0C709.744 0 914.301 204.557 914.301 456.891ZM185.804 456.891C185.804 606.895 307.406 728.497 457.41 728.497C607.413 728.497 729.015 606.895 729.015 456.891C729.015 306.888 607.413 185.286 457.41 185.286C307.406 185.286 185.804 306.888 185.804 456.891Z"
        fill="#339BFA"
      />
    </svg>
  );
};
